// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Source Sans 3', 'Source Sans 3 Fallback'"},"className":"__className_1c87f0"};